export default __webpack_public_path__ + "static/media/image-about-mission-w.1357ff03.png";